import { HiOutlineDocumentText } from 'react-icons/hi';

import { Content, Wrapper } from './styles';

export function NoContent() {
  return (
    <Wrapper>
      <Content>
        <HiOutlineDocumentText className="upload" />
        <p>Nenhum material de apoio disponível</p>
      </Content>
    </Wrapper>
  );
}
